<template>
  <div >
    <v-dialog v-model="dialog" persistent width="600">
      <v-btn flat slot="activator" class="primary--text">Reset Password</v-btn>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Reset Password</v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <p>Inserire l'email del proprio account per ricevere il link per il reset della password</p>
            </v-flex>
          </v-layout>
          <v-form ref="form">
            <v-layout row wrap>
              <v-flex xs12 sm8 md6 offset-sm2 offset-md3>
                <v-text-field v-model="email" :rules="emailRules" required label="Email"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm8 md6 offset-sm2 offset-md3>
                <v-btn color="success" @click="resetPassword()">Invia</v-btn>
                <v-btn color="error" @click="closeDialog()">Annulla</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as firebase from "firebase";
import { bus } from "../main";
export default {
  data: () => ({
    dialog: false,
    email: "",
    emailRules: [
      v => !!v || "E-mail necessaria",
      v => /[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(v) || "L'e-mail deve avere un formato valido"
    ]
  }),
  methods: {
    closeDialog() {
      this.$refs.form.reset();
      this.dialog = false;
    },
    resetPassword() {
      if (this.$refs.form.validate()) {
        var emailAddress = this.email;
        firebase
          .auth()
          .sendPasswordResetEmail(emailAddress)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Email di reset inviata con successo"
            );
          })
          .catch(error => {
            bus.$emit("errorOperation", "Errore: problema nell'invio dell'email per il reset della password(" + error +")");
          });
      }
    }
  }
};
</script>

